
import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";  // ✅ Import Outlet
import StaffSideBar from "./StaffSideBar";
import FooterNavStaff from "./FooterNavStaff";
import FloatingNavStaff from "./FloatingNavStaff";
import api from "../../utils/api";

const StaffLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const loadRestaurantCurrency = async () => {
      try {
        const isStaff = window.location.pathname.includes("/restaurant-staff/");
        const apiPrefix = isStaff ? "restaurant-staff" : "restaurant";
        const res = await api.get(`${apiPrefix}/restaurant/get`);
        if (res.success && res.data) {
          const biz = res.data;
          
          // Fetch currencies to match currency code
          const currencyRes = await api.get(`${apiPrefix}/currency/all`);
          if (currencyRes.success && Array.isArray(currencyRes.data)) {
            const matchedCurrency = currencyRes.data.find(
              (c) => String(c.id) === String(biz.currency_id)
            );
            if (matchedCurrency) {
              localStorage.setItem("currency", matchedCurrency.code || "INR");
            } else {
              localStorage.setItem("currency", "INR");
            }
          }
          
          const dec = biz.decimal_places !== undefined && biz.decimal_places !== null 
            ? Number(biz.decimal_places) 
            : 2;
          const safeDec = [2, 3, 4].includes(dec) ? dec : 2;
          localStorage.setItem("currencyDecimals", safeDec);
        }
      } catch (err) {
        console.error("Failed to load restaurant details/currency for staff:", err);
      }
    };

    const fetchLatestPermissions = async () => {
      try {
        const isStaff = window.location.pathname.includes("/restaurant-staff/");
        if (isStaff) {
          const res = await api.get("restaurant-staff/me");
          if (res.success && res.data) {
            const oldUserStr = localStorage.getItem("userData");
            if (oldUserStr) {
              const oldUser = JSON.parse(oldUserStr);
              // Check if permissions changed
              if (JSON.stringify(oldUser.permissions) !== JSON.stringify(res.data.permissions)) {
                console.log("Permissions updated from server. Reloading UI...");
                // Merge fresh permissions/roles into existing user data
                const updatedUser = { ...oldUser, ...res.data };
                localStorage.setItem("userData", JSON.stringify(updatedUser));
                window.location.reload(); // Force full reload to apply new permissions
              }
            }
          }
        }
      } catch (err) {
        console.error("Failed to fetch fresh staff profile:", err);
      }
    };
    
    loadRestaurantCurrency();
    fetchLatestPermissions();
    
    // Poll every 5 seconds for live permission updates
    const interval = setInterval(fetchLatestPermissions, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex h-screen">
      <StaffSideBar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 p-4 h-screen overflow-y-auto">
        <div className="flex justify-between items-center mb-4 md:hidden">
          <div className="font-bold text-lg">Stellaris</div>
          <button onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
        </div>

        {/* ✅ Nested routes will render here */}
        <Outlet />

        <FooterNavStaff /> 
     
     <FloatingNavStaff/>
      </div>
    </div>
  );
};

export default StaffLayout;
